import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { EHttpErrorStatus } from '../configurations/errors';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { QUERY_PARAMS, ROOT_ROUTES } from '../configurations/router';
import { EErrorId } from '../../shared/components/not-found/not-found.component';

export const accessDeniedInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if ((error.status as EHttpErrorStatus) === EHttpErrorStatus.noAccess) {
        void router.navigate([ROOT_ROUTES.notFound], {
          queryParams: {
            [QUERY_PARAMS.errorId]: EErrorId.accessDeniedTranscription,
          },
        });
      }
      return throwError(() => error);
    }),
  );
};
